"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Markdown;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Markdown(props) {
  var children = props.children;
  return /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, {
    source: children
  });
}

Markdown.defaultProps = {
  children: ''
};
Markdown.propTypes = {
  children: _propTypes.default.string
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/base/Markdown.js
// module id = 220
// module chunks = 0 15 16 17 18